import { useEffect } from 'react';
import PropTypes from 'prop-types';
import s from './ModelVariantList.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Banner from '../Banner/Banner';
import { initialModelVariantState } from '../../reducers/initialState';
import { useParams, Link } from 'react-router-dom';
import ModelVariantListTable from '../ModelVariantList/ModelVariantListTable';
import { IsWidgetAccessible, WidgetVisibility } from '../../utils/widgetManager';
import SearchBar from '../SearchBar/SearchBar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Cookies from 'js-cookie';
import ModelConfigurationContentTemplate from '../ModelTab/ModelConfigurationContentTemplate';
import Breadcrumb from '../WSAControls/Breadcrumb/BreadCrumb';
import Pagination from '../Pagination/Pagination';
import { DEFAULT_PAGE_SIZE, ModelCategoryPermission } from '../../constants';
import { getModelCategoryPermission } from '../../utils';




const ModelVariantList = ({ getModelVariants, modelVariantManager = { ...initialModelVariantState.modelVariantManager }, intl, userProfileWidgets, currentTimezone, setCurrentPage,
  setFilterData, userModelCategories }) => {
  let { ModelCategoryId, ModelId } = useParams();
  let filter = modelVariantManager.filter || '';
  let offset = modelVariantManager.offset || 0;
  let limit = modelVariantManager.limit || 1000;
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;

  let organisationId = Cookies.get(`selectedorganisationid-${envName}`) || 1;

  const onPageChangeHandler = currentPage => {
    setCurrentPage(currentPage);
  };



  const searchHandler = value => {
    setCurrentPage(1);
    filteredResults(value);
  };

  const filteredResults = value => {
    let filteredList = modelVariantManager.modelVariants;
    if (value !== '') {
      filteredList = modelVariantManager.modelVariants.filter(function (item) {
        return item.Name.toLowerCase().includes(value.toLowerCase());
      });
    }

    setFilterData({ filteredResults: { filteredResults: filteredList } });
  };

  const dataObj = Object.values(modelVariantManager.filteredResults);


  useEffect(() => {
    if (ModelId) {
      getModelVariants(ModelId, organisationId, offset, limit, filter, ModelCategoryId);
    }
  }, [getModelVariants, organisationId, ModelId, offset, limit, filter, ModelCategoryId]);

  let messageId = (modelVariantManager && modelVariantManager.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });


  const breadcrumbItems = [
    { label: <FormattedMessage id="modelcategory.modelcategory" defaultMessage="Model Category" />, href: '/operational-setup/model-category-list' },
    { label: <FormattedMessage id="model.models" defaultMessage="Models" />, href: `/operational-setup/model-category-configuration/${ModelCategoryId}/model-list` },
    { label: <FormattedMessage id="model.modelvariant" defaultMessage="Model Variants" /> } // Last item has no href (current page)
  ];


  const isUpdateAllowed = IsWidgetAccessible(userProfileWidgets, 'MODELVARIANTUPDATE');
  const isDuplicateAllowed = IsWidgetAccessible(userProfileWidgets, 'MODELVARIANTDUPLICATE');
  const isConfigurationAllowed = IsWidgetAccessible(userProfileWidgets, 'MODELVARIANTCONFIGURE');

   let isModelCategoryOwner = getModelCategoryPermission(userModelCategories, ModelCategoryId, ModelCategoryPermission.Owner)


  return (
    <div className={s.modelVariant}>
      {modelVariantManager.isLoading && <LoadingSpinner />}
      <Banner
        failureText={messageText}
        showBanner={modelVariantManager.showBanner}
        status={modelVariantManager.isOpSuccessful}
        successText={messageText}
      />
      <ModelConfigurationContentTemplate selectedPage="manageModelVariants" userProfileWidgets={userProfileWidgets}  intl={intl}>
        <div className={s.contentWrapper}>
          <div className={s.modelVariantHeader}>
            <div className={s.subHeading}>
              <FormattedMessage id="model.modelvariant" defaultMessage="Model Variants" />
              <span className={s.circle}>
                {modelVariantManager.modelVariants.length}
              </span>
            </div>
          </div>
          <div className='pb-3'>
            <Breadcrumb items={breadcrumbItems} />
          </div>
          <Row className={s.titleRows}>
            <Col sm={6} lg={4}>
              <SearchBar
                searchHandler={searchHandler}
                clearSearchInVisible={false}
                initialText={filter}
                placeHolderTextId="modelVariant.modelVariantName"
              />
            </Col>
            <Col sm={6} lg={8}>
              <Link to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-variant`}>
                <Button className={s.addbutton} style={WidgetVisibility(userProfileWidgets, `MODELVARIANTADD`)}>
                  + <FormattedMessage id="modelVariant.addNew" defaultMessage="ADD NEW" />
                </Button>
              </Link>
            </Col>
          </Row>

          <div className="">
            <Pagination
              data={dataObj}
              pageSize={DEFAULT_PAGE_SIZE}
              onPageChange={onPageChangeHandler}
              startingPage={modelVariantManager.currentPage}
            >
              <ModelVariantListTable
                ModelCategoryId={ModelCategoryId}
                ModelId={ModelId}
                UpdateAllowed={isUpdateAllowed}
                DuplicateAllowed={isDuplicateAllowed}
                ConfigurationAllowed={isConfigurationAllowed}
                currentTimezone={currentTimezone}
                IsModelCategoryOwner={isModelCategoryOwner}
              />
            </Pagination>
          </div>
        </div>
      </ModelConfigurationContentTemplate>
    </div>
  );
};


ModelVariantList.propTypes = {
  getModelVariants: PropTypes.func.isRequired,
  setPageFilter: PropTypes.func.isRequired,
  currentTimezone: PropTypes.string.isRequired
};

export default injectIntl(ModelVariantList);
